// extracted by mini-css-extract-plugin
export var menu = "BurgerMenu-module--menu--3W9fw";
export var list = "BurgerMenu-module--list--34rWy";
export var list__item = "BurgerMenu-module--list__item--3dujx";
export var list__item__link = "BurgerMenu-module--list__item__link--2_ZhA";